import { render, staticRenderFns } from "./InvestmentList.vue?vue&type=template&id=a9e85572&scoped=true"
import script from "./InvestmentList.vue?vue&type=script&lang=js"
export * from "./InvestmentList.vue?vue&type=script&lang=js"
import style0 from "./InvestmentList.vue?vue&type=style&index=0&id=a9e85572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e85572",
  null
  
)

export default component.exports